// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ce55aa97","667":"a264621e","977":"344cf110"}[chunkId] + ".chunk.js";
};